import {
  AlignItems,
  Box,
  JustifyContent,
  PlainLink,
  Space,
  TypeScale,
} from "@gocardless/flux-react";
import { Trans } from "@lingui/macro";

import {
  COOKIES_LINK,
  FEE_FREE_PROMO_TERMS_AND_CONDITIONS_LINK,
  PRIVACY_POLICY_LINK,
} from "../consts";

export const SignUpGetStartedFooter = () => (
  <Box
    width="100%"
    fontSize={TypeScale.Size_02}
    layout="flex"
    flexDirection="row"
    alignItems={AlignItems.Center}
    justifyContent={[JustifyContent.Start, null, null, JustifyContent.End]}
  >
    {typeof window !== "undefined" &&
      window.location.search.includes("promo=no-fees-90-days") && (
        <>
          <PlainLink
            href={FEE_FREE_PROMO_TERMS_AND_CONDITIONS_LINK}
            textDecoration="underline"
            target="_blank"
          >
            Terms and conditions apply
          </PlainLink>
          <Space h={2} layout="inline" />
        </>
      )}
    <PlainLink href={PRIVACY_POLICY_LINK} textDecoration="underline">
      <Trans id="Privacy Policy">Privacy Policy</Trans>
    </PlainLink>
    <Space h={2} layout="inline" />
    <PlainLink href={COOKIES_LINK} textDecoration="underline">
      <Trans id="Cookies">Cookies</Trans>
    </PlainLink>
  </Box>
);
